import { request } from "@/libs";
const timeout = 8000;

export default function requestResetPassword({user, email}) {
	return request("/server/request-password-reset",
		{
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ username: user, email })
		},
		timeout
	);
}



// WEBPACK FOOTER //
// ./src/api/request-reset-password.js